export default __webpack_public_path__ + "static/media/koleos-small.337842e5.jpg";